import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor() {}

  // Method to export an HTML table to Excel
  exportTableToExcel(table: any, filename: string): void {
    // PrimeNG's responsive "stack" layout injects a hidden <span class="p-column-title">
    // label into every cell for mobile view. XLSX reads raw innerHTML, so without this
    // clone-and-strip step those hidden labels get glued onto the real cell values.
    const clonedTable = table.cloneNode(true) as HTMLElement;
    clonedTable.querySelectorAll('.p-column-title').forEach((el: Element) => el.remove());

    // raw:true keeps every cell as plain text instead of auto-detecting numeric-looking
    // values (e.g. concatenated phone numbers) and converting them to numbers, which Excel
    // then renders in scientific notation and silently truncates precision on.
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(clonedTable, { raw: true });
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, filename);
  }

  // Method to export an array of objects to Excel
  exportToExcel(data: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  // Helper method to save the Excel file
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + EXCEL_EXTENSION);
  }
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
